import {
  Controller,
  FieldValues,
  FieldPath,
  useFormContext,
} from "react-hook-form";

import MultiAutocomplete from "./MultiAutocomplete";
import {
  MultiAutocompleteHookFormProps,
  MultiAutocompleteProps,
  MultiAutocompleteValue,
} from "./MultiAutocomplete.types";

const MultiAutocompleteHookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  Value extends TFieldValues[TName] = TFieldValues[TName]
>({
  name,
  defaultValue,
  rules,
  shouldUnregister,
  setPropsWithFormState,
  ...innerProps
}: MultiAutocompleteHookFormProps<TFieldValues, TName, Value>) => {
  const { control } = useFormContext<TFieldValues>();
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      control={control}
      render={(formState) => {
        const {
          field: { disabled, ref, onChange, ...innerField },
          formState: { errors },
        } = formState;
        const error = errors[name];
        const errorMsg = error?.message;
        const helperText =
          typeof errorMsg === "string" ? errorMsg : innerProps?.helperText;
        return (
          <MultiAutocomplete
            {...innerProps}
            {...innerField}
            inputRef={ref}
            error={!!error}
            helperText={helperText}
            disabled={
              typeof disabled === "boolean" ? disabled : innerProps.disabled
            }
            onChange={
              onChange as MultiAutocompleteProps<
                MultiAutocompleteValue<Value>
              >["onChange"]
            }
            {...(setPropsWithFormState?.(formState) ?? {})}
          />
        );
      }}
    />
  );
};

export default MultiAutocompleteHookForm;
